import { bsure, material, myfaro } from '@myfaro/themes-mui';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { THEME } from '../core/context';

export const selectTheme = (theme?: THEME): Theme => {
  if (!theme) return material;
  switch (theme) {
    case THEME.MYFARO:
      return myfaro;
    case THEME.BSURE:
      return bsure;
    default:
      return material;
  }
};
